<template>
  <ul class="b-icon-tabs__tabs">   
    <li v-for="item in lottieTabs" :key="item.id">
      <button
        type="button"
        class="b-icon-tabs__tab b-icon-tabs__tab--table"
        :class="selectedTab === item.type ? 'active' : ''"
        @click="clickedTab(item.type)">
        <Vue3Lottie
          :ref="`lottiePlayer-${item.id}`"
          :animation-link="item.lottie"
          :auto-play="false"
          :height="40"
          :width="40"
          @mouseover="lottiePlay(item)"
          @mouseleave="lottieStop(item)" />
      </button>
    </li>
  </ul>
</template>

<script>
// import LazyImage from './LazyImage.vue'
import { Vue3Lottie } from 'vue3-lottie'

export default {
  components: { Vue3Lottie },
  props: {
    lottieTabs: {
      required: true,
      type: Array,
    },
  },
  emits: ['changed-tab'],
  data() {
    return {
      selectedTab: 'table',
    }
  },
  mounted() {
    this.$emit('changed-tab', this.selectedTab)
  },
  methods: {
    clickedTab(type) {
      this.selectedTab = type

      console.log()
      this.$emit('changed-tab', this.selectedTab)
    },

    lottiePlay(item) {
      const lottie = this.$refs[`lottiePlayer-${item.id}`][0]
      lottie.play()
    },
    lottieStop(item) {
      const lottie = this.$refs[`lottiePlayer-${item.id}`][0]
      lottie.goToAndStop(0)
    },
  },
}
</script>
